<ee-banner *ngIf="banner != null" [banner]="banner" (clicked)="onClick()"></ee-banner>